import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import DyteText from './DyteText';
// import { SvgUri } from 'react-native-svg';
import { UIConfig } from '../types/ui-config/index';
import { defaultConfig } from '../lib/default-ui-config';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';

import DyteClient from '@dytesdk/web-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  meeting,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config = defaultConfig,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  states,
  t,
}: {
  meeting?: DyteClient;
  config?: UIConfig;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  const styles = StyleSheet.create({
    container: {
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.background[800],
    },
    textContainer: {
      backgroundColor: colors.background[900],
      padding: 16,
      borderRadius: 16,
    },
  });
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <DyteText>{t('ended.left')}</DyteText>
      </View>
    </View>
  );
}
